<template>
    <div class="wrapper">
        <div class="container">
            <div class="row flex-w mb_80 ApRow has-bg bg-boxed" style="background: no-repeat" data-bg_data=" no-repeat">
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 col-sp-12 ApColumn">
                    <div id="image-form_3092966142909674" class="block double-image ApImage">
                        <img src="https://cdn.shopify.com/s/files/1/0905/2012/files/station-h6.jpg?v=1632208549"
                            title alt style=" width: 100%; height: auto; " loading="lazy" />
                    </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 col-sp-12 ApColumn">
                    <div class="block text-flex ApHtml">
                        <h4 class="title_block">
                            The Stationery Company
                        </h4>
                        <div class="sub-title-widget">
                            The Stationery
                        </div>
                        <div class="block_content">
                            <p>
                                Our office supplies
                                will help you
                                organize your
                                workspace from all
                                kinds of desk
                                essentials to top
                                quality staplers,
                                calculators and
                                organizers.
                            </p>
                            <div>
                                <a href="/products" data-mce-href="#">Find out more<i
                                        class="fal fa-arrow-right"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>